import { formatMoney } from '@/neon/currency';
import selectors from '@/lib/selectors';

const {
  strings: { products: strings },
} = theme;

const { product: selector } = selectors;
const classes = {
  activeThumb: 'active-thumbnail',
  hide: 'hide',
};

export default function (node, variant) {
  const comparePrice = node.querySelector(selector.comparePrice);
  const compareEls = node.querySelectorAll(
    `${selector.comparePrice}, ${selector.comparePriceText}`
  );

  const productPrices = [...node.querySelectorAll(selector.price)];
  const unavailableString = strings.product.unavailable;

  if (!variant) {
    productPrices.forEach(el => (el.innerHTML = unavailableString));

    compareEls.forEach(el => (el.innerHTML = ''));
    compareEls.forEach(el => el.classList.add(classes.hide));
    return;
  }

  productPrices.forEach(el => (el.innerHTML = formatMoney(variant.price)));

  if (variant.compare_at_price > variant.price) {
    compareEls.forEach(
      el => (el.innerHTML = formatMoney(variant.compare_at_price))
    );
    compareEls.forEach(el => el.classList.remove(classes.hide));
  } else {
    compareEls.forEach(el => (el.innerHTML = ''));
    compareEls.forEach(el => el.classList.add(classes.hide));
  }
}
